import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ProductInventoryItemUtilsService } from '@app/modules/service-data/services/product-inventory-item-utils.service';
import { GetProductInventoryItemListAction } from '@app/modules/service-data/store/product-intentory-item.actions';
import { ProductInventoryItemState } from '@app/modules/service-data/store/product-inventory-item.state';
import { ExtendedProductInventoryItem } from '@app/modules/service-data/types/service-data.types';
import { ProductInventory } from '@core/core.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionType,
  DataTableActionsLocation,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { Observable, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-product-inventory-item-results',
  imports: [TranslateModule, DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './product-inventory-item-results.component.html',
})
export class ProductInventoryItemResultsComponent implements OnInit {
  private dialogRef = inject(NgbActiveModal);
  private piiUtilsService = inject(ProductInventoryItemUtilsService);
  private store = inject(Store);
  private translateService = inject(TranslateService);

  @Input() public piiIds: string[];

  protected dataTableConfiguration: DataTableConfiguration;
  protected isLoading = true;

  private rows$: Observable<ExtendedProductInventoryItem[]>;

  ngOnInit(): void {
    this.rows$ = this.store
      .dispatch(
        new GetProductInventoryItemListAction({ ids: this.piiIds }, null, false)
      )
      .pipe(
        switchMap(() =>
          this.store
            .select(ProductInventoryItemState.getProductInventoryItemsByIds)
            .pipe(
              switchMap((getProductInventoryItemsByIds) =>
                this.piiUtilsService.getExtendedProductInventoryItemList(
                  getProductInventoryItemsByIds(this.piiIds),
                  { partner: true, product: true }
                )
              ),
              tap(() => (this.isLoading = false))
            )
        )
      );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      actionsClasses: 'text-end',
      columns: [
        {
          label: 'pii.search.resultsTable.columns.barcode',
          property: 'kitId',
        },
        {
          label: 'pii.search.resultsTable.columns.partner',
          property: 'partner.name',
        },
        {
          label: 'pii.search.resultsTable.columns.product',
          property: 'product.internalName',
        },
      ],
      singleActions: [
        {
          name: 'pii.search.resultsTable.actions.openDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: this.openPiiDetails.bind(this),
        },
      ],
      rows$: this.rows$,
    };
  }

  private openPiiDetails(event: MouseEvent, pii: ProductInventory) {
    this.piiUtilsService.openDetails(pii.id);
    this.dismiss();
  }

  dismiss() {
    this.dialogRef.close();
  }
}
